import React from 'react'
import { LogIn, UserPlus } from 'lucide-react'
import './AuthFlow.scss'

const AuthChoice = ({ onChooseLogin, onChooseRegister }) => {
  const isValidObjectId = (id) => /^[a-fA-F0-9]{24}$/.test(id)
  const queryParams = new URLSearchParams(window.location.search)
  const logManager = isValidObjectId(queryParams.get('shopId'))
    ? queryParams.get('shopId')
    : null

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
        <p className='auth-subtitle'>
          Votre outil de gestion de commerce tout en 1
        </p>
      </div>

      <div className='auth-card'>
        <h2 className='auth-card-title'>Bienvenue</h2>
        <p className='auth-card-subtitle'>
          Connectez-vous{' '}
          {logManager
            ? 'à votre espace gérant'
            : 'ou créez un nouveau compte pour commencer'}
        </p>

        <div className='auth-choice-buttons'>
          {!logManager && (
            <button onClick={onChooseRegister} className='btn lg'>
              <UserPlus size={20} className='btn-icon' />
              Créer un compte
            </button>
          )}
          <button onClick={onChooseLogin} className='btn lg'>
            <LogIn size={20} className='btn-icon' />
            Se connecter
          </button>
        </div>

        <div className='auth-info'>
          <p>
            Gestion complète de vos produits, achats et clients
            <br />
            Accessible depuis n'importe quel appareil
          </p>
        </div>
      </div>

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default AuthChoice
